import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

ComparableColumns.propTypes = {
  column1: PropTypes.node.isRequired,
  column2: PropTypes.node.isRequired,
  column3: PropTypes.node.isRequired,
  column4: PropTypes.node.isRequired,
  column5: PropTypes.node.isRequired,
  column6: PropTypes.node.isRequired,
  column7: PropTypes.node.isRequired,
  onSelectClick: PropTypes.func.isRequired,
};

export default function ComparableColumns({
  column1,
  column2,
  column3,
  column4,
  column5,
  column6,
  column7,
  onSelectClick,
}) {
  return (
      <Grid container spacing={4}>
          <Grid className="column1" size={0.3} onClick={onSelectClick}>{column1}</Grid>
          <Grid className="column2" size={4}>{column2}</Grid>
          <Grid className="column3" size={1}>{column3}</Grid>
          <Grid className="column4" size={2}>{column4}</Grid>
          <Grid className="column5" size={1.5}>{column5}</Grid>
          <Grid className="column6" size={1}>{column6}</Grid>
          <Grid className="column7" size={2.1}>{column7}</Grid>
      </Grid>
  );
}